import { FolderPlayIcon } from './FolderPlayIcon';

/**
 * author: Colton Wiscombe
 * id C3FACC18-E546-4E6F-A140-48541C0B808E
 * name folder-play
 * version: 6.6.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/folder-play.svg
 * tags
 * - Files / Folders 
 */
export const FolderVideoIcon = FolderPlayIcon;
export default FolderVideoIcon